export const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov', '.ogg', '.m4v', '.ogv'];

/**
 * Checks whether a URL or path represents a video file.
 */
export function isVideoUrl(url?: string | null): boolean {
  if (!url || typeof url !== 'string') return false;
  const cleanUrl = url.trim().split('?')[0].toLowerCase();
  return (
    VIDEO_EXTENSIONS.some(ext => cleanUrl.endsWith(ext)) ||
    (url.includes('firebasestorage.googleapis.com') && url.toLowerCase().includes('videos%2f')) ||
    (url.toLowerCase().includes('video') && (url.includes('.mp4') || url.includes('.webm')))
  );
}

/**
 * Formats a media URL for browser playback (properly encodes spaces in filenames such as /Website video.mp4).
 */
export function formatMediaUrl(url?: string | null): string {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (trimmed.startsWith('/') || trimmed.startsWith('./')) {
    return encodeURI(trimmed).replace(/%2520/g, '%20');
  }
  return trimmed;
}
